import { HoldEventUnitView, ManageUnitsUnitView } from '@mark43/cad-api';
import { SortType } from '../../common/sorting/types';
import { getInverseDateSortValue } from '../../queues/utils/get-inverse-date-sort-value';

export const SortingParameterEnum = {
    DEFAULT: 'DEFAULT',
    CALL_SIGN: 'CALL_SIGN',
    DISPATCH_AREA: 'DISPATCH_AREA',
    STATUS: 'STATUS',
    TIME_IN_STATUS: 'TIME_IN_STATUS',
} as const;

export type SortingParameterName = keyof typeof SortingParameterEnum;

interface SortingParameter {
    name: SortingParameterName;
    display: string;
    getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => string | number | undefined;
    sortType: SortType;
}

export const sortingConfig: Record<SortingParameterName, SortingParameter> = {
    [SortingParameterEnum.DEFAULT]: {
        name: SortingParameterEnum.DEFAULT,
        display: 'Default',
        getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => {
            if ('sortKey' in item) {
                return item.sortKey;
            }
            return item.callSign.label;
        },
        sortType: 'alphabetical',
    },
    [SortingParameterEnum.CALL_SIGN]: {
        name: SortingParameterEnum.CALL_SIGN,
        display: 'Call Sign',
        getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => {
            return item.callSign.label;
        },
        sortType: 'alphabetical',
    },
    [SortingParameterEnum.DISPATCH_AREA]: {
        name: SortingParameterEnum.DISPATCH_AREA,
        display: 'Dispatch Area',
        getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => item.dispatchArea?.label,
        sortType: 'alphanumeric',
    },
    [SortingParameterEnum.STATUS]: {
        name: SortingParameterEnum.STATUS,
        display: 'Status',
        getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => item.statusCode || '',
        sortType: 'alphanumeric',
    },
    [SortingParameterEnum.TIME_IN_STATUS]: {
        name: SortingParameterEnum.TIME_IN_STATUS,
        display: 'Time in Status',
        getSortValue: (item: ManageUnitsUnitView | HoldEventUnitView) => {
            return getInverseDateSortValue(item.statusStartedDateUtc);
        },
        sortType: 'alphanumeric',
    },
};
